<div style="display: flex; text-align: justify;">
  <h1>Presupuesto {{budgetName}}</h1>
</div>
<div class="container">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label> Filtro Específico </mat-label>
      <mat-select [formControl]="filterDetails" (selectionChange)="cleanFilter()"
        matTooltip="Filtro por una columna de la tabla" matTooltipPosition="above">
        <mat-option value="0">Seleccione...</mat-option>
        <mat-option value="description" matTooltip="Filtro por la columna Descripción"
          matTooltipPosition="right">Descripción
        </mat-option>
        <mat-option value="reference" matTooltip="Filtro por la columna Referencia"
          matTooltipPosition="right">Referencia
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width-30vw" floatLabel="always"
      matTooltip="Valor a filtrar por columna seleccionada" matTooltipPosition="above">
      <mat-label> Valor </mat-label>
      <input matInput [formControl]="descriptionFilter" placeholder="Valor a filtrar..."
        (keyup)="applyFilterDetails($event)" #input2>
    </mat-form-field>
  </div>
  <div class="alert-danger" *ngIf="filterNoSelected">
    {{ messageError }}
  </div>
  <div fxLayout="row" fxHide.xs>
    <mat-form-field appearance="outline" class="full-width-30vw" floatLabel="always"
      matTooltip="Filtro por cualquier columna de la tabla" matTooltipPosition="above">
      <mat-label> Filtro General </mat-label>
      <input matInput [formControl]="descriptionSearch" (keyup)="applyFilterDetails($event)"
        placeholder="Valor a filtrar..." #input>
    </mat-form-field>
  </div>
</div>
<div class="table-overflow-240">
  <table mat-table cdk-table ngDefaultControl [(ngModel)]="dataSourceFilters" [dataSource]="dataSourceFilters"
    class="mat-elevation-z8">
    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> N° </th>
      <td mat-cell *matCellDef="let element; index as i;" align="center"> {{i + 1}} </td>
    </ng-container>
    <ng-container matColumnDef="chapterReference">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Ref. Capítulo </th>
      <td mat-cell *matCellDef="let element" align="center">
        {{element.chapterReference}} </td>
    </ng-container>
    <ng-container matColumnDef="reference">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Referencia </th>
      <td mat-cell *matCellDef="let element" align="center">
        {{element.reference}} </td>
    </ng-container>
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Código </th>
      <td mat-cell *matCellDef="let element" align="center">
        {{element.code}} </td>
    </ng-container>
    <ng-container matColumnDef="unit">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Unidad </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.unit}} </td>
    </ng-container>
    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Cantidad </th>
      <td mat-cell *matCellDef="let element" align="right">
        {{element.quantity | number:'1.2-2':'es'}} </td>
    </ng-container>
    <ng-container matColumnDef="unitPrice">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio Unitario Calculado (APU) </th>
      <td mat-cell *matCellDef="let element" align="right">
        {{element.unitPrice | number:'1.2-2':'es'}} </td>
    </ng-container>
    <ng-container matColumnDef="assumedPrice">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> PU Asumido (Precio Fijo) </th>
      <td mat-cell *matCellDef="let element" align="right">
        {{element.assumedPrice | number:'1.2-2':'es'}} </td>
    </ng-container>
    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Total </th>
      <td mat-cell *matCellDef="let element" align="right">
        {{element.total | number:'1.2-2':'es'}} </td>
        <td mat-footer-cell *matFooterCellDef class="mat-header-cell-datalaing"> Total General </td>
    </ng-container>
    <ng-container matColumnDef="performance">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Rendimiento </th>
      <td mat-cell *matCellDef="let element" align="right">
        {{element.performance | number:'1.6-6':'es'}} </td>
        <td mat-footer-cell *matFooterCellDef> {{ 1254 | number:'1.2-2':'es'}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-medium"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.selectedRow]="rowIsSelected(row.position)"
      (click)="onRowClick(row, $event)" (dblclick)="verDetallePartida(row)" style="cursor: pointer;"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="10">No hay data que filtrar</td>
      </tr>
      </table>
</div>
<div>
  <table class="mat-elevation-z8 div-inferior" style="margin-top: 1rem; margin-bottom: 1rem;">
    <tbody>
      <tr>
        <th class="mat-header-cell"
          style="width: 65%; border-top: 1px solid #ffff; border-bottom: none;border-left: none; border-right: none; padding-right: 24px !important;"></th>
        <td class="mat-cell" style="width: 12%;height: 10%;border-top: 1px solid #ffff; border-bottom: none;border-left: none; border-right: none;"></td>
          <th class="mat-header-cell label-black-bold"
            style="border-top: 1px solid #ffff; border-bottom: none;border-left: none;text-align: right !important;">
            Total
            Presupuesto:</th>
          <td class="mat-cell label-black-bold" style="width: 12%;height: 10%;text-align: right !important;">{{
            budgeTotal | number:
            '1.2-2':'es'
            }}</td>
          </tr>
      <tr>
        <th class="mat-header-cell label-black-bold"
          style=" width: 65%;border-top: none; border-bottom: none;border-left: none;text-align: right !important;padding-right: 24px !important;">
          Total Otros imp.({{ budgetOtherTax | number:'1.2-2':'es' }}%):</th>
        <td class="mat-cell" style="width: 12%;height: 10%;text-align: right !important;">{{ budgetTotalOtherTax | number:
          '1.2-2':'es' }}</td>
        <th class="mat-header-cell label-black-bold"
            style="border-top: none; border-bottom: none;border-left: none;text-align: right !important;">Total
            I.V.A.({{ budgetlIva | number:'1.2-2':'es' }}%):</th>
          <td class="mat-cell" style="width: 12%;height: 10%;text-align: right !important;">{{
            budgetTotalIva | number:
            '1.2-2':'es' }}</td>
      </tr>
      <tr>
        <th class="mat-header-cell" style="width: 65%;border: none;padding-right: 24px !important;"></th>
        <td class="mat-cell" style="width: 12%;height: 10%;border: none;"></td>
        <th class="mat-header-cell label-black-bold"
            style="border-top: none; border-bottom: none;border-left: none;text-align: right !important;">Total
            General:</th>
          <td class="mat-cell label-black-bold" style="width: 12%;height: 10%;text-align: right !important;">{{
            budgetGrandTotal | number:
            '1.2-2':'es' }}</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="mat-elevation-z8 div-inferior container-total-description" fxLayoutGap="10px">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">
    <mat-form-field appearance="outline" floatLabel="always" class="input-width-110">
      <mat-label>Total Partidas:</mat-label>
      <input matInput value="{{totalPartidas}}" autocomplete="off" disabled="true">
    </mat-form-field>
    <mat-form-field class="input-width-110" appearance="outline" floatLabel="always">
      <mat-label>Partida Actual:</mat-label>
      <input matInput value="{{partidaActual}}" autocomplete="off" disabled="true">
    </mat-form-field>
  </div>
  <mat-form-field appearance="outline" floatLabel="always" class="full-width-95" style="padding-right: 10px !important;">
      <mat-label>Descripción Partida:</mat-label>
      <textarea matInput value="{{descripcionPartida}}" disabled="true" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="7"></textarea>
  </mat-form-field>
</div>
<div class="container-button" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
  style="padding-top: 20px;">

  <button mat-raised-button class="buttons-text-center" (mouseenter)="closeExpansionPanel();"
    (click)="navigateHomePresupuesto();" color="warn">
    <mat-icon>reply_all</mat-icon>
    <span class="text-icon-space">Regresar</span>
  </button>

  <button mat-raised-button class="buttons-text-center" color="primary"
    (mouseenter)="closeExpansionPanel();" (click)="modificarPartida();">
    <mat-icon>edit_document</mat-icon>
    <span class="text-icon-space">Cantidad Partida</span>
  </button>

  <button mat-raised-button class="buttons-text-center" color="primary"
    (mouseenter)="closeExpansionPanel();" [matMenuTriggerFor]="menuInsumos">
    <mat-icon>summarize</mat-icon>
    <span class="text-icon-space">Ver Insumos</span>
  </button>
  <mat-menu class="customize" #menuInsumos="matMenu">
    <button mat-menu-item (click)="verMaterialesPresupuesto();">
      <mat-icon>widgets</mat-icon>
      <span>Materiales</span>
    </button>
    <button mat-menu-item (click)="verEquiposPresupuesto();">
      <mat-icon>construction</mat-icon>
      <span>Equipos</span>
    </button>
    <button mat-menu-item (click)="verManoDeObraPresupuesto();">
      <mat-icon>groups</mat-icon>
      <span>Mano de Obra</span>
    </button>
  </mat-menu>

  <button mat-raised-button class="buttons-text-center" color="primary"
    (mouseenter)="closeExpansionPanel();" [matMenuTriggerFor]="menu">
    <mat-icon>menu_open</mat-icon>
    <span class="text-icon-space">Opciones del Presupuesto</span>
  </button>
  <mat-menu class="customize" #menu="matMenu">
    <button mat-menu-item (click)="verDatosGeneralesPresupuesto()">
      <mat-icon>edit_note</mat-icon>
      <span>Datos Generales</span>
    </button>
    <button mat-menu-item (click)="verCondicionesApuPresupuesto()">
      <mat-icon>tune</mat-icon>
      <span>Condiciones APU</span>
    </button>
    <button mat-menu-item (click)="verCapitulosApuPresupuesto()">
      <mat-icon>library_books</mat-icon>
      <span>Capítulos</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="menuReportes">
      <mat-icon>print</mat-icon>
      <span>Reportes</span>
      </button>
      <mat-menu class="customize" #menuReportes="matMenu">
        <button mat-menu-item (click)="verDetallePresupuestoPDF()">Presupuesto</button>
        <button mat-menu-item (click)="verDetallePresupuestoConCapitulosPDF()">Presupuesto con Capítulos</button>
        <button mat-menu-item (click)="verResumenMaterialesPresupuestoPDF()">Resumen Materiales</button>
        <button mat-menu-item (click)="verResumenEquiposPresupuestoPDF()">Resumen Equipos</button>
        <button mat-menu-item (click)="verResumenManoObraresupuestoPDF()">Resumen Mano de Obra</button>
      </mat-menu>
      <button mat-menu-item (click)="VerPartidasPresupuesto()">
      <mat-icon>description</mat-icon>
      <span>Ver APU</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="menuExportarExcel">
      <mat-icon>downloading</mat-icon>
      <span>Exportar Excel</span>
    </button>
    <mat-menu class="customize" #menuExportarExcel="matMenu">
      <button mat-menu-item (click)="generarExcelPresupuesto(false)">Estructura de Costo</button>
      <button mat-menu-item (click)="generarExcelPresupuesto(true)">MaPreX Escritorio</button>
    </mat-menu>
    <button mat-menu-item (click)="capturarPartidasPresupuesto()">
      <mat-icon>upload_file</mat-icon>
      <span>Capturar Partidas</span>
    </button>
    <button mat-menu-item (click)="borrarPartidaPresupuesto()">
      <mat-icon>delete</mat-icon>
      <span>Borrar Partidas</span>
    </button>
  </mat-menu>
<button mat-raised-button class="buttons-text-center" color="primary"
  (mouseenter)="closeExpansionPanel();" (click)="actualizarPresupuesto()">
  <mat-icon>backup</mat-icon>
  <span class="text-icon-space">Guardar Presupuesto</span>
</button>
</div>
<div class="espacio-div" fxHide.xs fxHide.sm fxHide.md></div>
<div class="div-float" fxHide.xs fxHide.sm fxHide.md>
  <mat-accordion>
    <mat-expansion-panel [(expanded)]="xpandStatus" [disabled]="xpandDisabled">
      <mat-expansion-panel-header class='my-expansion-panel-header specific-class'>
        <mat-panel-title>
          APU Referencia: {{ referenciaPartida }}
        </mat-panel-title>
        <mat-panel-description>
          Precio Unitario: {{ precioUnitario | number: '1.2-2':'es' }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <br>
      <h4><strong>Costo Unit. Materiales: {{ costoUnicoMateriales | number: '1.2-2':'es' }}</strong></h4>
      <div style="overflow-y:auto; overflow-x:auto; max-height: 150px; max-width: 550px;">
        <table mat-table [dataSource]="dataSourceMaterial" class="mat-elevation-z8">
          <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing" style="width: 10%;"> Referencia </th>
            <td mat-cell *matCellDef="let element" align="center"> {{element.referenceMaterial}} </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell style="width: 40%;" *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
            <td mat-cell *matCellDef="let element"> {{element.materialDescription}} </td>
          </ng-container>
          <ng-container matColumnDef="unit">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Unid. </th>
            <td mat-cell *matCellDef="let element"> {{element.materialUnit}} </td>
          </ng-container>
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Cant. </th>
            <td mat-cell *matCellDef="let element" align="right"> {{ element.materialQuantity | number: '1.4':'es' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="waste">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Desp. </th>
            <td mat-cell *matCellDef="let element" align="right"> {{ element.wasteMaterial | number: '1.1':'es' }} </td>
          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.priceMaterial | number: '1.2':'es' }} </td>
          </ng-container>
          <ng-container matColumnDef="total">
            <th mat-header-cell align="center" *matHeaderCellDef class="mat-header-cell-datalaing"> Total </th>
            <td mat-cell align="right" *matCellDef="let element"> {{element.materialTotalPrice | number: '1.2':'es' }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsMaterial" class="mat-header-medium"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsMaterial;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="7">No aplica materiales para esta partida</td>
          </tr>
        </table>
      </div>
      <br>
      <h4><strong>Costo Unit. Equipos: {{ costoUnicoEquipo | number: '1.2-2':'es' }}</strong></h4>
      <div style="overflow-y:auto; overflow-x:auto; max-height:150px; max-width: 550px;">
        <table mat-table [dataSource]="dataSourceEquipo" class="mat-elevation-z8">
          <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;" class="mat-header-cell-datalaing"> Referencia </th>
            <td mat-cell *matCellDef="let element" align="center"> {{element.equipmentReference}} </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef style="width: 40%;" class="mat-header-cell-datalaing"> Descripción </th>
            <td mat-cell *matCellDef="let element"> {{element.equipmentDescription}} </td>
          </ng-container>
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Cant. </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.quantityEquipment | number: '1.2':'es'}}
            </td>
          </ng-container>
          <ng-container matColumnDef="waste">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> COP/Dep </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.depreciationEquipment | number: '1.6':'es'}}
            </td>
          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.priceEquipment | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef align="center" class="mat-header-cell-datalaing"> Total </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.equipmentTotalPrice | number: '1.2':'es'}}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsEquipos" class="mat-header-medium"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsEquipos;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="6">No aplica equipos para esta partida</td>
          </tr>
        </table>
      </div>
      <br>
      <h4><strong>Costo Unit. Mano de Obra: {{ costoUnicoManoDeObra | number: '1.2-2':'es' }} / % FCAS: {{
          porcPrestacionesManoDeObra }}</strong></h4>
      <div style="overflow-y:auto; overflow-x:auto; max-height:150px; max-width: 550px;" class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSourceManosObra" class="mat-elevation-z8">
          <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;" class="mat-header-cell-datalaing"> Referencia </th>
            <td mat-cell *matCellDef="let element" align="center"> {{element.laborReference}} </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef style="width: 40%;" class="mat-header-cell-datalaing"> Descripción </th>
            <td mat-cell *matCellDef="let element"> {{element.laborDescription}} </td>
          </ng-container>
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Cant. </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.quantityLabor | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="jornal">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Jornal </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.jornalLabor | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="bono">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Bono </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.priceLabor | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="totalbono">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Total Bono </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.laborTotalBonus | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="totaljornal">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Total Jornal </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.laborTotalJornal | number: '1.2':'es'}}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsManoObras" class="mat-header-medium"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsManoObras;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="6">No aplica mano de obra para esta partida</td>
          </tr>
        </table>
      </div>
      <br>
      <div class="container-fluid cew-9">
        <div class="row">
          <div class="col-7">
            <div class="mat-table" style="text-align: right;align-items:right;">
              <table class="mat-elevation-z8">
                <tbody>
                  <tr>
                    <th colspan="2" align="left" class="mat-header-cell" style="text-align: left !important;">
                      Costo Directo SubTotal A: <strong>{{costoDirectoSubTotalA | number: '1.2-2':'es'}}</strong>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="2" align="left" class="mat-header-cell" style="text-align: left !important;">
                      <span style="white-space: pre-line">
                        %Admin.: <strong>{{gastosGeneralesAdmin | number: '1.2-2':'es'}}</strong> %Util.:
                        <strong>{{utilidadesImprevisto| number: '1.2-2':'es'}}</strong> %O. Imp.: <strong>0,00</strong>
                      </span>
                      <span style="white-space: pre-line">
                        %Finan.: <strong>{{financiamiento| number: '1.2-2':'es'}}</strong> %IVA:
                        <strong>{{montoImpuestoIva| number: '1.2-2':'es'}}</strong>
                      </span>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="2" align="left" class="mat-header-cell" style="text-align: left !important;">
                      Números de Trabajadores: <strong>{{totalTrabajadores}}</strong>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="2" align="left" class="mat-header-cell" style="text-align: left !important;">
                      Números de Horas Trabajadas: <strong>{{workingHour}}</strong>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="2" align="left" class="mat-header-cell" style="text-align: left !important;">
                      Números de HH al Día: <strong>{{workingHourDay | number:'1.2-2':'es'}}</strong>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col">
            <strong>Descripción: </strong> {{ descripcionPartidaPanel }}
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>